import {
  TaskListProps,
  getResultList,
  deleteList,
  DeleteList,
  getBizAreaList,
  stopTask,
  retestTask,
  getTaskDetailUseCaseStatus,
  getTaskDetailUseCaseCount,
  getGroupList,
  getTaskExecList,
  getTaskCaseStatusList,
  getTaskCaseCount,
  CreateOfflineResultProps,
  createOfflineResult,
  downloadOfflinePackage,
  deleteTask,
  getTaskDetail,
  getTaskBaseInfo,
  importOfflineResult,
  getTaskDeviceList,
  getTaskTemplateList,
  TemplateCaseListProps,
  getTaskTemplateCaseList,
  getTaskTemplateCaseListAttackType,
  getHostList,
  pauseTask,
  startTask,
} from '@/api/endpoint-security/list'
import { ChangeJobStatus, changeJobStatus } from '@/api/endpoint-security/plans-task'
import { Message } from '@/components/message'
import { useRequest } from 'ahooks'
import { t } from '@/i18n'

// 获取任务列表
export const useGetTaskList = () => {
  const { runAsync: run, loading } = useRequest((params: TaskListProps) => getResultList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取任务列表失败'))
    },
  })

  return [run, loading] as const
}

// 获取任务执行列表
export const useGetTaskExecList = () => {
  const {
    runAsync: run,
    loading,
    data,
  } = useRequest((id: string, params: TaskListProps) => getTaskExecList(id, params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取任务执行列表失败'))
    },
  })

  return [run, loading, data?.data?.items || []] as const
}

// 子任务删除
export const useDeleteTaskExec = () => {
  const { runAsync: run, loading } = useRequest((data: DeleteList) => deleteList(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('子任务删除删除失败'))
    },
  })
  return [run, loading] as const
}

//获取安全域
export const useGetBizAreaList = () => {
  const { runAsync: run, data } = useRequest(() => getBizAreaList(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取安全域失败'))
    },
  })
  return [data?.data?.items || [], run] as const
}

// 停止任务
export const useStopTask = () => {
  const { runAsync: run } = useRequest(data => stopTask(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('任务停止失败'))
    },
  })
  return [run] as const
}

// 任务复测
export const useReTestTask = () => {
  const { runAsync: run, loading } = useRequest(data => retestTask(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('任务复测失败'))
    },
  })
  return [run, loading] as const
}

// 获取任务详情用例状态列表
export const useGetTaskDetailUseCaseStatus = () => {
  const { runAsync: run, data } = useRequest(params => getTaskDetailUseCaseStatus(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取例状态列表失败'))
    },
  })
  return [run, data?.data?.list || []] as const
}

// 任务结果 根据用例状态统计用例数
export const useGetTaskDetailUseCaseCount = () => {
  const { runAsync: run } = useRequest(params => getTaskDetailUseCaseCount(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取例状态列表失败'))
    },
  })
  return [run] as const
}

// 获取分组列表 (筛选)
export const useGetGroupList = () => {
  const { runAsync: run, data } = useRequest(() => getGroupList(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取分组列表失败'))
    },
  })

  return [run, data?.data?.list || []] as const
}

// 任务复测-获取任务详情用例状态列表
export const useGetTaskCaseStatusList = () => {
  const { runAsync: run } = useRequest((id: string) => getTaskCaseStatusList(id), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取任务详情用例状态列表失败'))
    },
  })

  return [run] as const
}

// 任务复测-根据用例状态统计用例数量
export const useCountCaseByStatus = () => {
  const { runAsync: run } = useRequest((id: string) => getTaskCaseCount(id), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取用例数量失败'))
    },
  })

  return [run] as const
}

// 获取任务详情
export const useGetTaskDetail = () => {
  const { runAsync: run } = useRequest((id: string) => getTaskDetail(id, {}), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取任务详情失败'))
    },
  })

  return [run] as const
}

// 创建离线任务结果
export const useCreateOfflineTaskResult = () => {
  const { runAsync: run, loading } = useRequest(
    (id: string, data: CreateOfflineResultProps) => createOfflineResult(id, data),
    {
      manual: true,
      onError(err: any) {
        Message.error(err?.msg || t('创建离线任务结果失败'))
      },
    },
  )

  return [run, loading] as const
}

// 下载离线验证包
export const useDownloadOfflinePackage = () => {
  const { runAsync: run, loading } = useRequest((id: string) => downloadOfflinePackage(id), {
    manual: true,
    // onError(err: any) {
    //   Message.error(err?.msg || '下载离线验证包失败')
    // },
  })

  return [run, loading] as const
}

// 主任务删除
export const useDeleteTask = () => {
  const { runAsync: run, loading } = useRequest((taskIds: string[]) => deleteTask(taskIds), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('删除任务失败'))
    },
  })

  return [run, loading] as const
}

// 获取任务基础信息
export const useGetTaskBaseInfo = () => {
  const { runAsync: run } = useRequest((id: string) => getTaskBaseInfo(id), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取任务基础信息失败'))
    },
  })

  return [run] as const
}

// 导入离线验证结果
export const useImportOfflineResult = () => {
  const { runAsync: run } = useRequest(
    (params: { fileId: string }) => importOfflineResult(params),
    {
      manual: true,
      onError(err: any) {
        Message.error(err?.msg || t('导入离线验证结果失败'))
      },
    },
  )

  return [run] as const
}

// 获取所有任务关联安全设备列表
export const useGetTaskDeviceList = () => {
  const { runAsync: run, data } = useRequest(() => getTaskDeviceList(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取所有任务关联安全设备列表失败'))
    },
  })

  return [data?.data?.list || [], run] as const
}

// 获取主任务关联模板列表
export const useGetTaskTemplateList = () => {
  const { runAsync: run, loading } = useRequest(
    (id: string, data: { page?: number; pageSize?: number; sortOrder?: string }) =>
      getTaskTemplateList(id, data),
    {
      manual: true,
      onError(err: any) {
        Message.error(err?.msg || t('获取主任务关联模板列表失败'))
      },
    },
  )

  return [run, loading] as const
}

// 获取主任务关联模板的用例列表
export const useGetTaskTemplateCaseList = () => {
  const { runAsync: run, loading } = useRequest(
    (id: string, templateId: string, data: TemplateCaseListProps) =>
      getTaskTemplateCaseList(id, templateId, data),
    {
      manual: true,
      onError(err: any) {
        Message.error(err?.msg || t('获取主任务关联模板的用例列表失败'))
      },
    },
  )

  return [run, loading] as const
}

// 获取主任务关联模板的用例列表的攻击类型
export const useGetTaskTemplateCaseListAttackType = () => {
  const { runAsync: run, data } = useRequest(
    (id: string, templateId: string) => getTaskTemplateCaseListAttackType(id, templateId),
    {
      manual: true,
      onError(err: any) {
        Message.error(err?.msg || t('获取主任务关联模板的用例列表的攻击类型失败'))
      },
    },
  )

  return [run, data?.data?.list || []] as const
}

// host列表筛选框
export const useGetHostList = () => {
  const { runAsync: run, data } = useRequest(() => getHostList(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取host列表筛选框失败'))
    },
  })

  return [run, data?.data?.list || []] as const
}

// 暂停主任务
export const usePauseTask = () => {
  const { runAsync: run } = useRequest((id: string) => pauseTask(id), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('暂停主任务失败'))
    },
  })

  return [run] as const
}

// 开启主任务
export const useStartTask = () => {
  const { runAsync: run } = useRequest((id: string) => startTask(id), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('开启主任务失败'))
    },
  })

  return [run] as const
}

// 暂停/重启计划任务
export const useChangeJobStatus = () => {
  const { runAsync: run } = useRequest((params: ChangeJobStatus) => changeJobStatus(params), {
    manual: true,
    onError(err: any) {
      // Message.error(err?.msg || '暂停/重启计划任务')
    },
  })

  return [run] as const
}
